import { ONE_DAY, ONE_MONTH } from './time';

export const COOKIE_LEGAL_MAX_LIFETIME = ONE_MONTH * 13;

export const COOKIES = {
  AUTH: {
    NAME: 'token',
    LIFETIME: COOKIE_LEGAL_MAX_LIFETIME
  },
  HAS_CONSENT: {
    NAME: 'hasConsent',
    LIFETIME: COOKIE_LEGAL_MAX_LIFETIME
  },
  LEGAL_AGE: {
    NAME: 'legal_age_notice',
    LIFETIME: ONE_MONTH
  },
  ESPOT_PROMO: {
    NAME: 'ESPOT_PROMO',
    LIFETIME: 0
  },
  ACT_AS: {
    NAME: 'actAsCustomer',
    LIFETIME: COOKIE_LEGAL_MAX_LIFETIME
  },
  TOP_BANNER_ESPOT: {
    NAME: 'espotTopBanner-',
    LIFETIME: ONE_MONTH
  },
  STOREID_FOR_PRICE: {
    NAME: 'storeIdForPrice',
    LIFETIME: COOKIE_LEGAL_MAX_LIFETIME
  },
  EXPRO: {
    NAME: 'expro',
    LIFETIME: ONE_DAY
  }
} as const;
